module.exports = __webpack_public_path__ + "img/no-exchange-order.dd36de96.png";